import { Link } from "react-router-dom";

export const Footer = () => {
  const cols = [
    {
      title: "Products",
      items: [
        { label: "Vsense Kids", to: "/shop?model=vsense-kids" },
        { label: "Vsense Adult", to: "/shop?model=vsense-adult" },
        { label: "The App", to: "/app" },
      ],
    },
    {
      title: "Company",
      items: [
        { label: "About", to: "/about" },
        { label: "Careers", to: "/careers" },
        { label: "Contact", to: "/contact" },
        { label: "Reviews", to: "/reviews" },
      ],
    },
    {
      title: "Support",
      items: [
        { label: "Contact", to: "/contact" },
        { label: "Warranty", to: "/warranty" },
        { label: "Shipping", to: "/shipping" },
        { label: "Returns", to: "/returns" },
      ],
    },
    {
      title: "Legal",
      items: [
        { label: "Privacy", to: "/privacy" },
        { label: "Terms", to: "/terms" },
        { label: "Cookies", to: "/cookies" },
        { label: "Licenses", to: "/licenses" },
      ],
    },
  ];
  return (
    <footer data-testid="site-footer" className="bg-[#F5F5F7] border-t border-black/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-display text-2xl font-extrabold tracking-tighter inline-block">
              Vsense<span className="text-zinc-400">.</span>
            </Link>
            <p className="mt-3 text-sm text-zinc-500 leading-relaxed max-w-xs">
              AI safety glasses that keep the people you love connected and protected.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-400 mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.items.map((i) => (
                  <li key={i.label}>
                    <Link
                      to={i.to}
                      data-testid={`footer-link-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
                    >
                      {i.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-black/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-400">
          <span>© {new Date().getFullYear()} Vsense. All rights reserved.</span>
          <span>Designed for the way you see the world.</span>
        </div>
      </div>
    </footer>
  );
};
